import { ReactNode, createContext, useContext, useState } from 'react'

interface SidebarContextType {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    toggleSidebar: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

interface SidebarProviderProps {
    children: ReactNode
    defaultOpen?: boolean
}

export function SidebarProvider({ children, defaultOpen = true }: SidebarProviderProps) {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    const toggleSidebar = () => setIsOpen(prev => !prev)

    return <SidebarContext.Provider value={{ isOpen, setIsOpen, toggleSidebar }}>{children}</SidebarContext.Provider>
}

export function useSidebarContext() {
    const context = useContext(SidebarContext)
    if (context === undefined) {
        throw new Error('useSidebarContext must be used within a SidebarProvider')
    }
    return context
}
